/**
 * @generated SignedSource<<7ab6098e059e5904e97bc928f5304198>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaymentPixAutomaticQRCode_subscription$data = {
  readonly pixRecurring: {
    readonly emv: string | null | undefined;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentPixAutomaticLinkShareButton_subscription">;
  readonly " $fragmentType": "PaymentPixAutomaticQRCode_subscription";
};
export type PaymentPixAutomaticQRCode_subscription$key = {
  readonly " $data"?: PaymentPixAutomaticQRCode_subscription$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentPixAutomaticQRCode_subscription">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaymentPixAutomaticQRCode_subscription",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "PixRecurring",
      "kind": "LinkedField",
      "name": "pixRecurring",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "emv",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentPixAutomaticLinkShareButton_subscription"
    }
  ],
  "type": "PaymentSubscription",
  "abstractKey": null
};

(node as any).hash = "451c594deea42ba851bda86e91e2abdf";

export default node;
